import React from "react";
import PdfViewer from "./PdfViewer";

export default function CocProtocol() {
  const pdfUrl =
    "https://drive.google.com/file/d/1lnOxYXdqP8842h3u-CY9QkqSixYIoKIZ/view";

  return (
    <div>
      <PdfViewer />
    </div>
  );
}
